import type {SocialAccount} from '@Components/social-media/account.vo';

export interface SocialAccountRowMenuProps {
  account: SocialAccount;
  className?: string;
  onRefreshAccount: VoidFunction;
  onMenuOpened: VoidFunction;
  onMenuClosed: VoidFunction;
}

export const SOCIAL_ACCOUNT_ROW_MENU_REFRESH_ITEM_ID = 'social-account-row-menu-refresh';
export const SOCIAL_ACCOUNT_ROW_MENU_DELETE_ITEM_ID = 'social-account-row-menu-delete';
